// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1x0hM","containerItemsCenter":"Skeleton_containerItemsCenter__3SmRM"};